export const getSerraDaEstrelaData = () => ({
  name: "Serra da Estrela",
  country: "Portugal",
  region: "Dão",
  description: "Serra da Estrela est une sous-région montagneuse du Dão, produisant des vins rouges et blancs de qualité avec des cépages autochtones.",
  type: "subregion",
  mapAreas: [
    { region: "Serra da Estrela", x: 40, y: 32, color: "#4B164C", size: 4 }
  ],
  statistics: {
    totalArea: "2,000 ha",
    production: "80,000 hl",
    wineries: "30+ quintas",
    villages: "6 villages",
    exportPercentage: "40%"
  },
  characteristics: {
    climate: "Climat continental montagneux, étés chauds, hivers froids",
    soil: "Sols granitiques, schisteux, altitude élevée",
    viticulture: "Viticulture traditionnelle, vignes en altitude"
  },
  wineStyles: {
    red: "Rouges élégants et structurés, tanins fermes, notes de fruits rouges",
    white: "Blancs secs et aromatiques, acidité vive, notes d'agrumes"
  },
  history: "Serra da Estrela produit des vins depuis l'époque romaine. La région est connue pour ses vins de montagne de qualité.",
  foodPairing: "Viandes rouges, gibier, fromages affinés, cuisine portugaise",
  grapeVarieties: [
    {
      name: "Touriga Nacional",
      percentage: "30%",
      description: "Cépage roi du Portugal, produisant des vins complexes et aromatiques",
      characteristics: "Complexe, aromatique, tanins fermes, notes de violette",
      wineStyles: "Sec, plein-corps, tannique"
    },
    {
      name: "Tinta Roriz",
      percentage: "25%",
      description: "Cépage d'assemblage, apportant structure et couleur",
      characteristics: "Structuré, coloré, tanins fermes, notes de fruits noirs",
      wineStyles: "Sec, plein-corps, tannique"
    },
    {
      name: "Alfrocheiro",
      percentage: "20%",
      description: "Cépage autochtone, apportant élégance et fruité",
      characteristics: "Élégant, fruité, tanins soyeux, notes de fruits rouges",
      wineStyles: "Sec, moyen-corps, fruité"
    },
    {
      name: "Jaen",
      percentage: "15%",
      description: "Cépage autochtone, apportant acidité et fraîcheur",
      characteristics: "Acidité vive, fraîcheur, notes d'agrumes",
      wineStyles: "Sec, léger, frais"
    },
    {
      name: "Encruzado",
      percentage: "10%",
      description: "Cépage blanc principal, produisant des vins secs et aromatiques",
      characteristics: "Sec, aromatique, notes d'agrumes et de fleurs",
      wineStyles: "Sec, léger, aromatique"
    }
  ]
}); 